"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrency = formatCurrency;
var MAX_CURRENCY_PRECISION = 2;

function formatCurrency(amount) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_CURRENCY_PRECISION;

  if (precision <= 1 && isWholeAmountByPrecision(amount, 0)) {
    return "$".concat(amount | 0);
  }

  if (precision <= 1 && isWholeAmountByPrecision(amount, 1)) {
    return "$".concat(amount.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '&,'));
  } // Always return with precision of two decimal points as default


  return formatAmount(amount, MAX_CURRENCY_PRECISION);
}

function isWholeAmountByPrecision(amount, precision) {
  return Math.pow(10, precision) * amount % 1 === 0;
}

function formatAmount(amount, precision) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}